import * as actions from './activity-actions';
import * as mutations from './activity-mutations';
import { state } from './activity-state';

export const activity = {
  state,
  mutations,
  actions,
};
